<div class="root" *transloco="let t; read:'permit'">
    <ng-container *ngIf="basicDetails$ | async as basicDetails">
        <ng-container>
            <h1 class="root__heading" [innerHTML]="(showFlammableAtexPermitCreated$ | async)
                ? t('flammableAtexPermitCreated.heading', { workplace: basicDetails.fullWorkplaceName })
                : t('completed.heading', { workplace: basicDetails.fullWorkplaceName })"></h1>
            <div class="root__button" (click)="refresh()">{{ (showFlammableAtexPermitCreated$ | async) ? t("flammableAtexPermitCreated.goBack") : t("completed.showPermit") }}</div>
        </ng-container>
    </ng-container>
</div>
